import { render } from "./JointAttachments.vue?vue&type=template&id=643d366f"
import script from "./JointAttachments.vue?vue&type=script&lang=js"
export * from "./JointAttachments.vue?vue&type=script&lang=js"

import "./JointAttachments.vue?vue&type=style&index=0&id=643d366f&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__